class MFRRotatingImage {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
            image: ".rotating-image img"
        }

        this.init();
    }

    init() {
        this.$image = this.$element.find( this.selectors.image );

        this.initAnimation();
    }

    initAnimation() {
        gsap.to( this.$image, {
            rotate: 1080,
            scrollTrigger: {
                trigger: this.$element,
                start: "top bottom",
                end: "bottom top",
                scrub: true
            }
        })
    }
}